import {observable, action, makeObservable} from 'mobx'
import {injectable} from 'inversify'

import {IGlobalLoaderStore} from './IGlobalLoaderStore'
import {LoadingState} from '@/types/common/LoadingState'

@injectable()
export class GlobalLoaderStore implements IGlobalLoaderStore {
    loadingState = LoadingState.LOADING

    constructor() {
        makeObservable(this, {
            loadingState: observable,
            setGlobalLoading: action.bound,
            showGlobalLoader: action.bound,
            hideGlobalLoader: action.bound
        })
    }

    setGlobalLoading(loading: boolean): void {
        this.loadingState = loading ? LoadingState.LOADING : LoadingState.IDLE
    }

    showGlobalLoader(): void {
        this.loadingState = LoadingState.LOADING
    }

    hideGlobalLoader(): void {
        this.loadingState = LoadingState.IDLE
    }
}
